<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <p>{{data.message}}</p>
    <table mat-table matSort [dataSource]="scanBatchItems" class="batch-items-list">
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let item">
                {{item.item.id}}
            </td>
        </ng-container>

        <ng-container matColumnDef="in_stock">
            <th mat-header-cell *matHeaderCellDef>In stock</th>
            <td mat-cell *matCellDef="let item">
                <mat-checkbox [disableRipple]="true" (click)="$event.preventDefault()" color="primary"
                    [checked]="isInStock(item.item)">In stock</mat-checkbox>
            </td>
        </ng-container>


        <ng-container matColumnDef="scanned">
            <th mat-header-cell *matHeaderCellDef>Scanned</th>
            <td mat-cell *matCellDef="let item">
                <mat-checkbox [disableRipple]="true" (click)="$event.preventDefault()" color="primary"
                    [checked]="item.scanned">Scanned</mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="barcode">
            <th mat-header-cell *matHeaderCellDef>Barcode</th>
            <td mat-cell *matCellDef="let item">
                <p class="code">
                    <mat-form-field appearance="outline">
                        <mat-label>Barcode</mat-label>
                        <input required matInput id="{{item.inputId}}" [formControl]="item.barcodeControl" placeholder="Barcode">
                    </mat-form-field>
                </p>
            </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>

            <td *matCellDef="let item">
                <button class="me-2" (click)="focusItem(item)" mat-stroked-button>
                    Scan
                </button>
                <button [disabled]="item.barcodeControl.invalid" class="me-2" (click)="submit(item)" mat-flat-button
                    color="primary">
                    Submit
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [length]="totalNumberOfBatchItems" [pageIndex]="page-1" [pageSize]="limit"
        [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons (page)="onPageChange($event)"
        aria-label="Select page of orders">
    </mat-paginator>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button (click)="closeDialog()" color="primary" cdkFocusInitial>
        <mat-icon>done</mat-icon> Done
    </button>
</div>